export default __webpack_public_path__ + "static/media/ethereum-new.48170956.svg";